module.exports = __webpack_public_path__ + "static/media/threshold.a80e8ab7.png";